import { MinorIdmissionIDValidationMobile } from './MinorIdmissionIDValidationMobile';

export default function VerifyMinorIDScreen() {
  return <MinorIdmissionIDValidationMobile />;
}
